/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React, { Fragment, useRef } from 'react'
// import { isMobile } from 'react-device-detect'
// import moment from 'moment'
import { FaRegComment, FaRetweet, FaRegHeart } from 'react-icons/fa'
// import { IconX } from '../helpers/Star'

// eslint-disable-next-line no-unused-vars
const Tweet = ({ tweet, tweetClose, setTweetClose }) => {
  const ref = useRef()

  if (Object.keys(tweet).length === 0) {
    return null
  }

  const { body, comments, likes, retweets, photo_url } = tweet

  // const time = moment(timestamp).format('MMMM Do YYYY, h:mm:ss a')
  const image = photo_url[0]

  return (
    <Fragment>
      <div className="tweet" ref={ref}>
        {/* {!isMobile ? null : <IconX className="close-button" onClick={() => setTweetClose(true)} />} */}
        {/* <IconX className="close-button" onClick={() => setTweetClose(true)} /> */}
        <p className="tweetBody">{body}</p>
        {!photo_url[0] ? null : <img className="tweetImage" src={image} />}
        {/* <div className="tweetTime">{time}</div> */}
        <div className="tweetData">
          <span>
            <FaRegComment /> {comments}
          </span>
          <span>
            <FaRetweet /> {retweets}
          </span>
          <span>
            <FaRegHeart /> {likes}
          </span>
        </div>
      </div>
    </Fragment>
  )
}
export default Tweet
